/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { invalidateSelectedContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage, displayModal } from '@insticator/insticator-ui'; // iui-state
// component
import OrganizeContentCTA from 'material/ctas/organizecontent/organizecontent';



/* ========== ~~~~~~~~~~ CTA : ORGANIZE CONTENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
	const contentStatus = embedsState.embedManagementState.contentStatus;
	return {
    	selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null
	}
};

// map actions
const mapDispatchToProps = dispatch => ({
	displayModal: (isVisible, contentToDisplay, showCloseButton) => {
		dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
	},
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(OrganizeContentCTA);
